export default __webpack_public_path__ + "/dist/images/7813904.png";